import { fetch as fetchPolyfill } from 'whatwg-fetch'
import http from '@/api/http'

export default {
    getCheckUserInfo(cb,form) {
        http.post('/api/netzeroSystem/merchant/checkUserInfo', cb, form)
    },
}



// WEBPACK FOOTER //
// ./src/api/user.js